import appLogger from "@next-platform/client-common-core/logger/appLogger";

const logger = appLogger.withTag("handleSpeechRecognitionError");

// handeling valid and invalid errors
export const handleSpeechRecognitionError = (error: string) => {
  switch (error) {
    case "no-speech":
      logger.debug("No speech detected.");
      break;
    case "aborted":
      logger.debug("Speech input aborted.");
      break;
    case "audio-capture":
      logger.warn("Audio capture failed.");
      break;
    case "network":
      logger.warn("Network error.");
      break;
    case "not-allowed":
      logger.warn("Speech input not allowed.");
      break;
    case "service-not-allowed":
      logger.warn("Recognition service not allowed.");
      break;
    case "bad-grammar":
      logger.error("Error in grammar or tags.");
      break;
    case "language-not-supported":
      logger.warn("Unsupported language.");
      break;
    default:
      logger.error("Error in speech recognition: " + error);
  }
};
